import { render, staticRenderFns } from "./Step02.vue?vue&type=template&id=bb44d5c6&"
import script from "./Step02.vue?vue&type=script&lang=js&"
export * from "./Step02.vue?vue&type=script&lang=js&"
import style0 from "./Step02.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports